module.exports = __webpack_public_path__ + "static/15-formation-deformation-s-xiii-4ddd30298c2b05325730023d951417c8.jpg";